<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 font_regular">Market correction employees ({{totalCount}})</p>
         </div>
         <div class="popup-close">
          <button class="download-btn" (click)="exportToExcel()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
 
    </ion-col>
  </ion-row>
  
  <ion-row>
    <ion-col size="12">
      <div class="table-container">
      <table class="Market-correction-employees-table">
        <thead>
          <tr>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Department
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Band 
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Employee
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Manager
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                HOD
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                DOJ
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Market Benchmark CTC
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Market Correction %
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Market Correction Ammount
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let department of getMarketCorrectionEmpData">
            <ng-container *ngFor="let band of department.bandGrades; let i = index">
              <ng-container *ngFor="let employee of band.employeeData; let j = index">
                <tr>
                  <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                    {{department.departmentName}}
                  </td>
                  <td *ngIf="j === 0" [attr.rowspan]="band.employeeData.length">
                    {{ band.band }}
                  </td>
                  <td>{{employee.employeeName}}</td>
                  <td>{{employee.managerName}}</td>
                  <td>{{employee.hodName}}</td>
                  <td>{{employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                  <td>{{employee.marketBenchMarkCtc | number}}</td>
                  <td>{{employee.marketCorrectionPercentage | number}}</td>
                  <td>{{employee.marketCorrectionAmount | number}}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
       </tbody>
       <tfoot>
        <tr>
          <td colspan="6" class="total">Total</td>
          <td class="total">{{marketBenchmarkCtcTotal | number}}</td>
          <td class="total">{{marketCorrectionPercentageTotal | number}}</td>
          <td class="total">{{marketCorrectionAmountTotal | number}}</td>
        </tr>
       </tfoot>
      </table>
      </div>
    </ion-col>
  </ion-row>
</div>